export default __webpack_public_path__ + "static/media/951.5baedd50.png";